import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 70686 64007"
    {...props}
  >
    <defs>
      <style>
        {/* {".str0{stroke:#000;stroke-width:783.412}.fil0{fill:#1c1b17}"} */}
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974613604256">
        <path
          d="M21515 4497C20230-942 48721-905 47707 4179l-4135 20731c-6195-3989-11885-3504-17232 1L21515 4497zM35190 27760c4427 0 8016 3590 8016 8017s-3589 8015-8016 8015-8016-3588-8016-8015 3589-8017 8016-8017zM69109 39596c5352 1606-8924 26263-12821 22843L40403 48491c6552-3371 8978-8540 8616-14924l20090 6029zM14776 63221C10709 67053-3506 42360 1404 40696l20021-6784c-356 7360 2908 12045 8616 14923L14776 63221z"
          className="fill stroke1"
          style={{
            strokeWidth: 783.412,
          }}
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
